import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Table } from "components/Table";
import { TableSection } from "features/Research/v2/components/StockDetailPage/StockDetailPage.styles";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "./YourActiveHoldings.styles";
import { columns } from "./columns";
import { useActiveHoldings } from "features/Strategy/hook/useActiveHoldings";

const AccountsHoldings = () => {
  const { id: strategyId } = useParams();

  const { data: activeHoldingsData, isLoading } = useActiveHoldings(strategyId);

  // Transform API data to match expected format
  const formattedHoldings = useMemo(() => {
    if (!activeHoldingsData?.data) return [];

    return activeHoldingsData?.data?.map((item, index) => ({
      id: index + 1,
      account: item.broker || "--",
      imageUrl: item?.logo_url || "",
      positions: item.positions,
      averagePrice: item.average_price,
      totalValue: item.total_values,
      allTimeReturn: {
        amount: item.all_time_return?.formatted_number,
        percent: item.all_time_return?.formatted_percentage,
      },
      investedSince: item.invested_since,
    }));
  }, [activeHoldingsData]);

  if (formattedHoldings?.length === 0) return null;

  return (
    <TableSection>
      <Card>
        <CardHeader>
          <CardTitle>Your active holdings</CardTitle>
        </CardHeader>
        <CardContent>
          <Table
            data={formattedHoldings}
            columns={columns}
            isLoading={isLoading}
            notFoundText={`No account holdings data available`}
            showPagination={false}
          />
        </CardContent>
      </Card>
    </TableSection>
  );
};

export default AccountsHoldings;
